module.exports = __webpack_public_path__ + "fonts/1b70446.woff";